import { useLanguage } from '@monthio/react-components'
import i18next from 'i18next'
import { useEffect, VoidFunctionComponent } from 'react'

export const LanguageChangeListener: VoidFunctionComponent = () => {
	const language = useLanguage()
	useEffect(() => {
		if (language != null) {
			i18next.changeLanguage(language.toLowerCase())
		}
	}, [language])

	return null
}
